import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import router from "@/router";
import { debounce } from "lodash";
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  // store.dispatch("unit/getAll");
  store.dispatch("maintenance/getAll");
  store.dispatch("service_orders_status/getAll");
  store.dispatch("maintenance_template/getAll");
  store.dispatch('maintenance_crew/getAll')
  const refListTable = ref(null);
  const toast = useToast();
  const unitOptions = computed(() => store.getters["unit/getSelectedItems"]);
  const unitFilter = ref(null);
  const maintenanceOptions = computed(() => store.getters["maintenance/getSelectedItems"]);
  const maintenanceFilter = ref(null);
  const maintenanceCrewOptions = computed(() => store.getters["maintenance_crew/getSelectedItems"]);
  const maintenanceCrewFilter = ref(null);
  const statusOptions = computed(() => store.getters["service_orders_status/getSelectedItems"]);
  const statusItems = computed(() => store.getters["service_orders_status/getItems"]);
  const statusFilter = ref(null);
  const dateFilter = ref(null)
  const startDate = ref(null)
  const endDate = ref(null)
  const change = computed(() => store.getters['user/getChangeTraslate'])
  const maintenanceTemplateOptions = computed(() => store.getters["maintenance_template/getSelectedItems"]);

  store.dispatch("maintenance_template/getAll");
  const templateOptions = computed(() => store.getters["maintenance_template/getSelectedItems"]);
  const templateFilter = ref(null);

  if (router.currentRoute.params.name) unitFilter.value = parseInt(router.currentRoute.name);

  const tableColumns = [{
    label: "actions.name",
    key: "actions"
  }, {
    label: "service_orders.reference_number",
    key: "reference_number",
    sortable: true
  }, {
    label: "service_orders.company",
    key: "company.name",
    sortable: true
  },
  {
    label: "maintenance.maintenance_crew",
    key: "maintenance_crew.description",
    sortable: true
  },
  { label: "service_orders.facility", key: "unit.description", sortable: true }, {
    label: 'service_orders.attention_date',
    key: 'attention_date',
    sortable: true,
    formatter: 'formatDateAssigned'
  }, {
    label: 'service_orders.status', key: 'latest_status', sortable: false,
  }, {
    label: 'service_orders.status_change_date',
    key: 'status[0].updated_at',
    sortable: false,
    formatter: 'formatDateAssigned'
  }, {
    label: 'maintenance.template', key: 'template.name', sortable: true,
  }, {
    label: 'date.created_at',
    key: 'created_at',
    sortable: true,
    formatter: 'formatDateAssigned'
  }, {
    label: 'date.updated_at',
    key: 'updated_at',
    sortable: true,
    formatter: 'formatDateAssigned'
  },];

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    if (sortBy.value !== "") {
      //let id_units_array = null
      if (unitFilter.value != null && !Array.isArray(unitFilter.value)) {
        //id_units_array = unitFilter.value.map(item => item.value);
        unitFilter.value = [unitFilter.value];
      }
      store
        .dispatch("service_orders/getAll", {
          q: searchQuery.value,
          max: perPage.value,
          "page[n]": currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          id_unit: unitFilter.value,//id_units_array,
          id_maintenance_company: maintenanceFilter.value,
          id_maintenance_crew : maintenanceCrewFilter.value,
          id_status: statusFilter.value,
          id_template: templateFilter.value,
          date_filter: dateFilter.value,
          start_date: startDate.value,
          end_date: endDate.value,
        })
        .then((response) => {
          console.log(response.data, "datos");
          callback(response.data);
          totalList.value = response.meta.total;
        })
        .catch(() => {
          toast({
            component: ToastificationContent, props: {
              title: "Error obteniendo la información",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    }
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([currentPage, perPage], () => {
    refetchData();
  });


  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({});
    const filtersCount = useFilterCounter(filters);
    const buildFilters = () => {
      filters.value = {
        id_unit: unitFilter.value,
        id_maintenance_company: maintenanceFilter.value,
        id_maintenance_crew : maintenanceCrewFilter.value,
        id_status: statusFilter.value,
        id_template: templateFilter.value,
        date_filter: dateFilter.value,
        start_date: startDate.value,
        end_date: endDate.value,
      };
      refetchData();
    }
    const clearSearchFilters = () => {
      unitFilter.value = null;
      maintenanceFilter.value = null;
      maintenanceCrewFilter.value = null;
      templateFilter.value = null;
      statusFilter.value = null;
      dateFilter.value = null;
      startDate.value = null;
      endDate.value = null;
      buildFilters();
    }

  return {
    maintenanceTemplateOptions,
    statusOptions,
    statusFilter,
    maintenanceOptions,
    maintenanceFilter,
    maintenanceCrewOptions,
    maintenanceCrewFilter,
    refListTable,
    unitOptions,
    unitFilter,
    tableColumns,
    perPage,
    totalList,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    fetchList,
    formatDateAssigned,
    refetchData,
    dateFilter,
    startDate,
    endDate,
    change,
    statusItems,
    clearSearchFilters,
    buildFilters,
    filtersCount,
    templateOptions,
    templateFilter,
  };
}
